// extracted by mini-css-extract-plugin
module.exports = {"noop":"DisputeDetails_noop__vcjO6","correctedInvoiceRequested":"DisputeDetails_correctedInvoiceRequested__2ucTZ"};